module.exports = __webpack_public_path__ + "img/logo_biocloudaurum.a0bd8bdb.png";